import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Toggle from "react-toggle";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import { ToastContainer } from "react-toastify";
import "./style.scss";
import {
  changeCompanyModal,
  requestAddPaymentMethod,
  requestUpdatePaymentMethod,
} from "../../../../../redux/actions/company";

const Index = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(
    (state) => state.company.showModals.updatePaymentMethod
  );
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );

  const updateError = useSelector(
    (state) => state.company.updatePaymentMethod.error
  );
  const updateLoading = useSelector(
    (state) => state.company.updatePaymentMethod.loading
  );

  const defaultMethod = useSelector(
    (state) => state.company.paymentMethods?.default
  );
  const activeMethod = useSelector(
    (state) => state.company.activePaymentMethod.id
  );

  const [toggled, setToggled] = useState(false);

  const handleClose = () => {
    dispatch(changeCompanyModal({ updatePaymentMethod: false }));
  };

  const clickUpdateMethod = () => {
    if (
      (toggled && activeMethod === defaultMethod) ||
      (!toggled && activeMethod !== defaultMethod)
    ) {
      dispatch(changeCompanyModal({ updatePaymentMethod: false }));
    } else {
      if (toggled) {
        dispatch(
          requestUpdatePaymentMethod({
            companyId: companyId,
            primary: activeMethod,
          })
        );
      } else {
        dispatch(
          requestUpdatePaymentMethod({ companyId: companyId, primary: null })
        );
      }
    }
  };

  useEffect(() => {
    if (updateError) {
      sendErrorNotification(updateError);
    }
  }, [updateError]);

  useEffect(() => {
    if (activeMethod == defaultMethod) {
      setToggled(true);
    }
  }, [activeMethod, defaultMethod, setToggled]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre betalingsmetode"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={updateLoading ? "Oppdaterer.." : "Oppdater"}
          icon={
            updateLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i class="fas fa-sync-alt"></i>
            )
          }
          onClick={() => clickUpdateMethod()}
          type="button"
        />,
      ]}
    >
      <div className="edit-payment-method-popup-content">
        <Row className="info-row">
          <Col className="info-col my-auto">
            <Label version={1} weight="bold">
              Sett som primærvalg
            </Label>
            <p>
              Dette kortet vil bli forsøkt trukket først ved neste fakturering.
            </p>
          </Col>
          <Col className="toggle-col my-auto text-right">
            <Toggle
              checked={toggled}
              icons={false}
              onChange={() => setToggled(!toggled)}
              className="select-toggle"
            />
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
